"use client";

import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";

interface PublicOnlyGuardProps {
  children: React.ReactNode;
}

export function PublicOnlyGuard({ children }: PublicOnlyGuardProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
